import Action from "@Actions/action";
import config from "@Config";
import { setConsent } from "firebase/analytics";
import { hashEmail } from "@Helpers/analytics-utils";

export type UpdateConsentPayload = {
  consent: boolean;
  actionType: UpdateConsent;
}

/**
 * Update Consent
 * @description Update the user's consent to tracking
 * @param {UpdateConsentPayload} payload
 * @param {boolean} payload.consent - Whether to grant or revoke consent
 */
export default class UpdateConsent extends Action {
  runAction() {
    /** GRANT CONSENT & LOAD TRACKERS */
    if (this._payload.consent) {

      // Snapchat Pixel - Grant consent and initialize with hashed email
      if (window.snaptr) {
        const hashedEmail = hashEmail(this._state.user.email as string | null);
        
        window.snaptr('consent', 'grant');
        if (hashedEmail) {
          window.snaptr('init', (config as any).snapchat_pixel_id, {
            'email_hash': hashedEmail
          });
        } else {
          window.snaptr('init', (config as any).snapchat_pixel_id);
        }
      }

      // Facebook Pixel
      if (window.fbq) {
        window.fbq('init', (config as any).facebook_pixel_id);
        window.fbq('consent', 'grant');
      }

      // Google Tag Manager
      if (window.gtag) {
        window.localStorage.setItem("consentGranted", "true");
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted',
          functionality_storage: 'granted',
          personalization_storage: 'granted'
        });
      }

      // Bing UET
      window.uetq = window.uetq || [];
      window.uetq.push('consent', 'update', {
        ad_storage: 'granted',
      });

      // Firebase Analytics
      setConsent({
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted'
      });

      // Amplitude - Reinitialize after consent is granted
      this._amplitude.setOptOut(false);
      this._amplitude.init(config.amplitude_api_key, undefined, {
        disableCookies: false,
        saveEvents: true,
        includeReferrer: true,
        includeUtm: true
      });

      /** REVOKE CONSENT */
    } else {
      // Snapchat Pixel
      if (window.snaptr) {
        window.snaptr('consent', 'deny');
      }

      // Facebook Pixel
      if (window.fbq) {
        window.fbq('consent', 'revoke');
      }

      // Google Tag Manager
      if (window.gtag) {
        window.localStorage.setItem("consentGranted", "false");
        window.gtag('consent', 'update', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          analytics_storage: 'denied',
          functionality_storage: 'denied',
          personalization_storage: 'denied'
        });
      }

      // Bing UET
      window.uetq = window.uetq || [];
      window.uetq.push('consent', 'update', {
        ad_storage: 'denied',
      });

      // Amplitude - Ensure tracking is disabled
      this._amplitude.setOptOut(true);

      // Firebase Analytics
      setConsent({
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'denied',
        personalization_storage: 'denied'
      });

    }
  }
}
